export default "__VITE_ASSET__B02KadOx__"